// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getUserUndeletedAnnotationCount = async ({
    test,
}: {
    test: boolean,
}): Promise<number> => {
    const functions = getFunctions();
    const handleGetUserUndeletedAnnotationCount = httpsCallable<
        Record<
            string,
            boolean
        >,
        number
    >(
        functions,
        'getUserUndeletedAnnotationCount',
    );
    return handleGetUserUndeletedAnnotationCount({
        test,
    }).then((result) => {
        const count = result.data as number;
        return count;
    }).catch((err) => {
        throw err;
    });
};

export default getUserUndeletedAnnotationCount;
